import { ProfessionalServerModel } from '@domain/entities/professional.model';
import {
    DataTableColumnType,
    DataTableConfig,
} from '@shared/components/data-table/data-table.types';

export const ProfessionTableConfig: DataTableConfig = {
    firstFetch: true,
    mediaQuery: false,
    paginator: {
        show: true,
        pageIndex: 0,
        pageSize: 10,
        showFirstLastButtons: true,
        pageSizeOptions: [5, 10, 25],
    },
    columns: [
        {
            name: 'identification',
            label: 'Identificación',
            displayed: true,
            disable_sort: false,
            type: DataTableColumnType.Text,
            attribute: 'id',
        },
        {
            name: 'name',
            label: 'Nombre',
            displayed: true,
            disable_sort: false,
            type: DataTableColumnType.Text,
            attribute: 'name',
        },
        {
            name: 'lastName',
            label: 'Apellido',
            displayed: true,
            disable_sort: false,
            type: DataTableColumnType.Text,
            attribute: 'lastName',
        },
        {
            name: 'address',
            label: 'Direccion',
            displayed: true,
            disable_sort: false,
            type: DataTableColumnType.Text,
            attribute: 'address',
            hideOn: ['xs', 'sm'],
        },
        {
            name: 'email',
            label: 'Correo',
            displayed: true,
            disable_sort: false,
            type: DataTableColumnType.Text,
            attribute: 'email',
            hideOn: ['xs', 'sm', 'md'],
        },
        {
            name: 'phone',
            label: 'Telefono',
            displayed: true,
            disable_sort: false,
            type: DataTableColumnType.Text,
            attribute: 'phone',
            hideOn: ['xs', 'sm', 'md'],
        },
    ],
};

export const ProfessionalMock: ProfessionalServerModel[] = [
    {
        id: '5725a680b3249760ea21de52',
        name: 'Abbott',
        lastName: 'Keitch',
        email: 'abbott@withinpixels.com',
        phone: '+1-202-555-0175',
        address: '933 8th Street Stamford, CT 06902',
        state: 'Activo',
    },
    {
        id: '5725a680606588342058356d',
        name: 'Arnold',
        lastName: 'Matlock',
        email: 'arnold@withinpixels.com',
        phone: '+1-202-555-0141',
        address: '906 Valley Road Michigan City, IN 46360',
        state: 'Activo',
    },
    {
        id: '5725a68009e20d0a9e9acf2a',
        name: 'Barrera',
        lastName: 'Bradbury',
        email: 'barrera@withinpixels.com',
        phone: '+1-202-555-0196',
        address: '183 River Street Passaic, NJ 07055',
        state: 'Activo',
    },
    {
        id: '5725a6809fdd915739187ed5',
        name: 'Blair',
        lastName: 'Strangeway',
        email: 'blair@withinpixels.com',
        phone: '+1-202-555-0118',
        address: '143 Jones Street Eau Claire, WI 54701',
        state: 'Activo',
    },
    {
        id: '5725a68007920cf75051da64',
        name: 'Boyle',
        lastName: 'Winters',
        email: 'boyle@withinpixels.com',
        phone: '+1-202-555-0177',
        address: '218 Pearl Street Brandon, FL 33510',
        state: 'Activo',
    },
    {
        id: '5725a68031fdbb1db2c1af47',
        name: 'Christy',
        lastName: 'Camacho',
        email: 'christy@withinpixels.com',
        phone: '+1-202-555-0136',
        address: '329 Bridge Street Desoto, TX 75115',
        state: 'Activo',
    },
    {
        id: '5725a680bc670af746c435e2',
        name: 'Copeland',
        lastName: 'Redcliff',
        email: 'copeland@withinpixels.com',
        phone: '+1-202-555-0107',
        address: '956 6th Avenue North Bergen, NJ 0704',
        state: 'Activo',
    },
    {
        id: '5725a680e7eb988a58ddf303',
        name: 'Estes',
        lastName: 'Stevens',
        email: 'estes@withinpixels.com',
        phone: '+1-202-555-0113',
        address: '664 York Street Cambridge, MA 02138',
        state: 'Activo',
    },
    {
        id: '5725a680dcb077889f758961',
        name: 'Harper',
        lastName: 'MacGuffin',
        email: 'harper@withinpixels.com',
        phone: '+1-202-555-0173',
        address: '738 Route 11 Cornelius, NC 28031',
        state: 'Activo',
    },
    {
        id: '5725a6806acf030f9341e925',
        name: 'Helen',
        lastName: 'Sheridan',
        email: 'helen@withinpixels.com',
        phone: '+1-202-555-0163',
        address: '194 Washington Avenue Saint Petersburg, FL 33702',
        state: 'Activo',
    },
];

/* LAST CONFIGURATION */

/* 
<!-- SEARCH -->
<!-- <app-search-input
              placeholder="Buscar por cédula"
              [filter]="true"
              [filter_fields]="filter_fields"
              (onSearch)="search_subject.next($event)"
              (onFilter)="filter_subject.next($event)">
          </app-search-input> -->
<!-- / SEARCH -->

<!-- <div id="professional-list" class="page-layout carded w-full inner-scroll">
    <div class="center p-0">
        <div class="flex items-center justify-between bg-card p-3">
            <app-header-title
                title="Profesionales"
                icon="people"
            ></app-header-title>

            
            <div>search Input</div>
            <div class="flex">
                <button mat-raised-button>
                    <span>CREAR</span>
                </button>
            </div>
        </div>
        <div class="content-card">
            <app-data-table
                [config]="dt_config"
                [source$]="dt_source$"
                [search$]="search_subject"
                [filter$]="filter_subject"
            >
            </app-data-table>
        </div>
    </div>
</div> -->

public dt_config: DataTableConfig = ProfessionTableConfig;

public dt_source$: DataTableSource<ProfessionalServerModel>;

public search_subject = new Subject<string>();

public filter_subject = new Subject<string>();

public filter_fields: FilterField[] = [];

constructor(private _professionalUseCase: ProfessionalUsecase) {}

ngOnInit(): void {
    const connector = (params: HttpParams) => {
        return this._professionalUseCase.getAllProfessional(params);
    };

    this.dt_source$ = new DataTableSource(connector);

    // add filters field
    this.dt_config.columns.forEach((item) => {
        if (AllowedFilters.includes(item.type)) {
            this.filter_fields.push({
                label: item.label,
                attribute: item.attribute,
                type: item.type,
            });
        }
    });
} */
